module.exports = __webpack_public_path__ + "media/src/images/progress/ci_paylight-34ba1a39064c093570ef65cecb4947ac.jpg";